import { store } from 'react-notifications-component';
import { Http } from '../../services/Http';
import JSZip from "jszip";
import { clearStorageValues, getAuthData, getCurrentUser, getUserAccessToken, setUserAccessToken } from '../../services/selectors/Accounts';

//Common function to validate the API return status.
export function getStatus(apiResult) {

	// TODO -- After the new API integration is complete, the if block will be removed
	if (apiResult && (apiResult.data.result || apiResult.data.result >= 0)) {
		if ((apiResult && (apiResult.data.result || apiResult.data.result >= 0) && apiResult.data.status) || (apiResult === '')) {
			return {
				value: apiResult.data.status.statusValue,
				message: apiResult.data.status.statusDisplay
			}
		}
		return {
			value: false,
			message: apiResult.data.status.statusDisplay
		};
	} else {
		if ((apiResult && apiResult.data  && apiResult.data.status)) {
			return {
				value: apiResult.data.isSuccess,
				message: apiResult.data.status
			}
		}
		return {
			value: false,
			message: apiResult.data.status
		};
	}
}

export const exceptionHandler = (res) => {
	if (res.status === 200 && res.statusText === "OK") {
		return { status: true, data: res.data }
	} else {
		if (res.status === 400) {
			return { status: false, data: res.data.status }
		} else {
			return { status: false, data: res.statusText }
		}
	}
}

export const exceptionHandlerForUpdate = (res) => {
	if (res.status === 200 && res.statusText === "OK") {
		if(res.data.isSuccess){
			return { status: true, data: res.data }
		} else {
			return { status: false, data: res.data }
		}
	} else {
		if (res.status === 400) {
			return { status: false, data: res.data.status }
		} else {
			return { status: false, data: res.statusText }
		}
	}
}

export const showAlert = (message, isError) => {	
	if (message === '') { return; }
	store.addNotification({
		id: 'showAlertContainer',
		title: isError ? "Error..!" : "Success!",
		message: (message && message !== null) ? message : "",
		type: isError ? "danger" : "success",
		insert: "top",
		container: isError ? "center" : "top-right",
		animationIn: ["animate__animated", "animate__fadeIn"],
		animationOut: ["animate__animated", "animate__fadeOut"],
		dismiss: isError ? { duration: 0,click:false, touch: false, showIcon: true } : {duration: 5000,onScreen: true}		
	});
}

export const showAlertWithBacktrack = (message, isError, history) => {	
	if (message === '') { return; }
	store.addNotification({
		id: 'showAlertContainer',
		title: isError ? "Error..!" : "Success!",
		message: (message && message !== null) ? message : "",
		type: isError ? "danger" : "success",
		insert: "top",
		container: isError ? "center" : "top-right",
		animationIn: ["animate__animated", "animate__fadeIn"],
		animationOut: ["animate__animated", "animate__fadeOut"],
		dismiss: isError ? { duration: 0,click:false, touch: false, showIcon: true } : {duration: 5000,onScreen: true}		,
		onRemoval: () => {
			history.goBack();
		  }
	});
}

//Cleans the browsers cache, if the new version is deployed in prod.
export function clearCache(packageVersion) {
	let version = localStorage.getItem('version');
	if (version !== packageVersion) {
		if ('caches' in window) {
			caches.keys().then((names) => {
				// Delete all the cache files
				names.forEach(name => {
					caches.delete(name);
				})
			});

			// Makes sure the page reloads. Changes are only visible after you refresh.
			window.location.reload();
		}
		localStorage.clear();
		localStorage.setItem('version', packageVersion);
	}
};

export const Capitalize = (char) => {
	if (typeof char !== 'string') return ''
	return char.toLowerCase().split(' ').map(s => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
}

export const clearFilterExcept = (pageToExclude='') => {
	pageToExclude = pageToExclude.trim().toLowerCase();

	if (pageToExclude != "episode") {
		sessionStorage.removeItem("episodeFilter");
	}
}

export function getCookie(cookieName)
{
	let cookie = {};
	var cookieArray = document.cookie.split(';');
	cookieArray.forEach(function (cookiePair)
	{
		let [key, value] = cookiePair.split('=');
		cookie[key.trim()] = value;
	})
	var cookieValue = "";

	if (document.cookie.indexOf(cookieName) != -1) {
		cookieValue = cookie[cookieName];
	}
	return cookieValue;
}

export function clearRefreshToken() {
	const currentDate = new Date();
	const pastDate = new Date();
	pastDate.setDate(currentDate.getDate() - 2);
	let pastDateUtc = pastDate.getUTCDate();
	window.document.cookie = "refreshToken=;expires=" + pastDateUtc;
}

export function getSessionTimeout() {
	let loginData = getCurrentUser();
	let sessionTimeout = 0;
	if (loginData && loginData.sessionTimeout) {
		var sessionTimeoutValue = parseInt(loginData.sessionTimeout)
		if (!isNaN(sessionTimeoutValue))
			sessionTimeout = sessionTimeoutValue;
	}
	return sessionTimeout;
}

export function handleLogout(isSessionExpired) {
	const frontLogged = sessionStorage.getItem('fp-Log');
	return Http.axios().get('/Account/SignOutbyClient')
		.then((e) => {
			clearStorageValues();
			if (isSessionExpired) {
				sessionStorage.setItem("memoryRoute", window.location.pathname);
				window.localStorage.setItem('isLoggedoutbyclient', "auto");
			} else {
				window.localStorage.setItem('isLoggedoutbyclient', "yes");
			}
			window.location.href = (window.location.pathname != '/front' && window.location.pathname != '/unauth' && !frontLogged) ? "/" : '/front';
		})
		.catch((e) => {
		})
}

export async function renewToken() {
	try {
		const token = getUserAccessToken();
		let result = await Http.axios().post('/api/Auth/renew-token', JSON.stringify({ accessToken: token }), { headers: { 'Authorization': token } });
			if (result && result.status == 200 && result.data && result.data.accessToken){
				var authData = getAuthData();
				if (authData) {
					setUserAccessToken(result.data.accessToken);
					handleTime();
					return true;
				}else {
					return false;
				}
			}else {
				return false;
			}
	}
	catch (e) {
		return false;
	}
}

export const updateAccessToken = async (token) => {
	if (token != "" && token!=null) {
		await setUserAccessToken(token);
		await handleTime();
		return true;
	} else {
		return false;
	}	
}

export function handleTime() {
	const then = Date.now() + (getSessionTimeout() - getRenewalStartingTime());
	window.localStorage.setItem('SESSIONEXPIRY', "" + then);
}

export function validateAccessTokenExpiry() {
	var accessToken = getUserAccessToken();
	var accessTokenExpiry = window.localStorage.getItem('SESSIONEXPIRY');
	var validToken = false;

	if (accessToken && accessToken.trim().length != 0 && Date.now() < Number(accessTokenExpiry) + getRenewalAllowedTime()) {
		validToken = true;
	}
	return validToken;
}

export const handleGetWaitOnAction = () => {
	var isWaitOnIdleToActionFlag: boolean;
	isWaitOnIdleToActionFlag = false;

	var then = window.localStorage.getItem('SESSIONEXPIRY');
	if (Date.now() > Number(then) + getRenewalAllowedTime()) {
		var isRenewalInProgressFlag: Boolean;
		isRenewalInProgressFlag = getRenewalInProgress();

		if (!isRenewalInProgressFlag) {
			isWaitOnIdleToActionFlag = true;
			handleAutoLogout();
		}
	}
	return isWaitOnIdleToActionFlag;
}

export const handleAutoLogout = () => {
	const frontLogged = sessionStorage.getItem('fp-Log');
	var refreshTokenValue = getCookie("refreshToken") || localStorage.getItem('refreshToken');
	setRenewalInProgress(false.valueOf.toString());

	if (refreshTokenValue != null && refreshTokenValue.length > 0) {
		clearStorageValues();
		sessionStorage.setItem("memoryRoute", window.location.pathname)
		window.location.href = (window.location.pathname != '/front' && window.location.pathname != '/unauth' && !frontLogged) ? "/" : '/front';
	}
	else {
		handleLogout(true);
	}
}

export const getRenewalInProgress = () => {
	const renewalInStorage = sessionStorage.getItem('renewalInProgress');
	var flag = false;

	if (renewalInStorage == null) {
		flag = false;
	}
	else {
		if (renewalInStorage == "true")
			flag = true;
		else
			flag = false;

	}
	return flag;
}

export const setRenewalInProgress = (flag) => {
	var flagValue = false;
	if (flag != null)
		flagValue = flag

	sessionStorage.setItem('renewalInProgress', flagValue.valueOf().toString());
}

export const getRenewalStartingTime = () => {
	const renewalStartingTime = 120000;
	return renewalStartingTime;
}

export const getRenewalWaitingTime = () => {
	const renewalWaitingTime = 105000;
	return renewalWaitingTime;
}

export const getRenewalAllowedTime = () => {
	const renewalAllowedTime = 90000;
	return renewalAllowedTime;
}

export const handleDownloadZip = async (attachment) => {
	const zip = new JSZip();

	for (let i = 0; i < attachment.length; i++) {
		try {
			const url = attachment[i];
			const response = await fetch(url);
			if (!response.ok) throw new Error(`Failed to fetch: ${url}`);

			const blob = await response.blob();

			const filename = `attachement_${i + 1}.mp3`;
			zip.file(filename, blob);
		} catch (error) {
			console.error(attachment[i], error);
		}
	}

	await zip.generateAsync({ type: "blob" }).then((content) => {
		const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
		const a = document.createElement("a");
		a.href = URL.createObjectURL(content);
		a.download = `attachements_${timestamp}.zip`;
		a.click();
		URL.revokeObjectURL(a.href);
	});
};





